export default defineNuxtLink({
  componentName: 'AppLink',
  externalRelAttribute: '',
  activeClass: 'is-active',
  exactActiveClass: 'is-exact',
});
